import { type ReactNode, useEffect } from 'react';
import { NavLink, useLocation } from '../router';

const navigation = [
  ['About', '/about'],
  ['Learning', '/learning'],
  ['Activities', '/activities'],
  ['Graduates', '/graduates'],
  ['News', '/news'],
  ['Support', '/support'],
] as const;

function Brand({ footer = false }: { footer?: boolean }) {
  return (
    <span className={footer ? 'footer-brand' : 'brand'}>
      <span className={`brand-mark ${footer ? 'brand-mark-footer' : ''}`}><img src="/images/htl-logo-transparent.png" alt="" width="160" height="160" /></span>
      <span className="brand-copy"><strong>Hsa Thoo Lei</strong><small>Learning Center{footer ? '' : ' · Mae Sot'}</small></span>
    </span>
  );
}

export function SiteLayout({ children }: { children: ReactNode }) {
  const location = useLocation();
  useEffect(() => {
    const target = location.hash ? document.querySelector<HTMLElement>(location.hash) : null;
    if (target) target.scrollIntoView(); else window.scrollTo({ top: 0, behavior: 'auto' });
    document.querySelector<HTMLElement>('#main-content')?.focus({ preventScroll: true });
  }, [location.pathname, location.hash]);

  return (
    <>
      <a className="skip-link" href="#main-content">Skip to content</a>
      <div className="brand-ribbon" aria-hidden="true"><span /></div>
      <header className="site-header">
        <NavLink to="/" aria-label="Hsa Thoo Lei home"><Brand /></NavLink>
        <nav className="desktop-nav" aria-label="Main navigation">
          {navigation.map(([label, to]) => <NavLink key={to} className={({ isActive }) => isActive ? 'is-active' : ''} to={to}>{label}</NavLink>)}
        </nav>
        <NavLink className="header-cta" to="/contact">Contact <span aria-hidden="true">→</span></NavLink>
        <details className="mobile-menu">
          <summary aria-label="Open navigation"><span aria-hidden="true">☰</span></summary>
          <nav aria-label="Mobile navigation">
            <NavLink to="/">Home</NavLink>
            {navigation.map(([label, to]) => <NavLink key={to} to={to}>{label}</NavLink>)}
            <NavLink to="/contact">Contact</NavLink>
          </nav>
        </details>
      </header>
      <main id="main-content" tabIndex={-1}>{children}</main>
      <footer className="site-footer">
        <div className="footer-grid">
          <div className="footer-intro"><Brand footer /><p>Education, belonging, and hope for migrant and internally displaced children in Mae Sot, Thailand.</p></div>
          <div className="footer-links"><p className="footer-label">Explore</p>{navigation.slice(0, 5).map(([label, to]) => <NavLink key={to} to={to}>{label === 'About' ? 'About our school' : label}</NavLink>)}</div>
          <div className="footer-contact"><p className="footer-label">Contact</p><a href="mailto:htl_maesot@yahoo.com">✉ <span>htl_maesot@yahoo.com</span></a><a href="tel:+66892687708">☎ <span>+66 89 268 7708</span></a><a href="https://maps.google.com/?q=644+Samak+Sapphakarn+Road+Mae+Sot+Tak+63110+Thailand" target="_blank" rel="noreferrer">⌖ <span>644 Samak Sapphakarn Rd, Mae Sot, Tak</span></a></div>
        </div>
        <div className="footer-bottom"><p>© {new Date().getFullYear()} Hsa Thoo Lei Learning Center</p><p className="footer-motto"><span aria-hidden="true">●</span> Learning together since 1999</p></div>
      </footer>
    </>
  );
}

